import { createNanoEvents } from 'nanoevents'

const eventEmitter = createNanoEvents()
const subscriptions = {}

export function pub(eventName, ...args) {
  if (process.env.NODE_ENV !== 'production') {
    console.debug(`publish ${eventName}: ${JSON.stringify(args)}`)
  }
  eventEmitter.emit(eventName, ...args)
}

export function sub(eventName, namespace, callback) {
  const unbind = eventEmitter.on(eventName, callback)
  subscriptions[namespace] = subscriptions[namespace] || []
  subscriptions[namespace].push(unbind)

  return unbind
}

export function unsub(namespace) {
  for (const unbind of subscriptions[namespace] || []) {
    unbind()
  }
}
